import type { NavigateFunction } from "react-router-dom";

let navigator: NavigateFunction | null = null;

export function setNavigator(navigate: NavigateFunction) {
  navigator = navigate;
}

export function navigateTo(
  to: string,
  options?: { replace?: boolean; state?: any }
) {
  if (!navigator) {
    console.warn("Navigator not ready yet");
    return;
  }
  navigator(to, options);
}
